import React from 'react';
import { ArrowDownTrayIcon, XMarkIcon } from './Icons';

interface PWAInstallerProps {
  onInstall: () => void;
  onDismiss: () => void;
}

const PWAInstaller: React.FC<PWAInstallerProps> = ({ onInstall, onDismiss }) => {
  return (
    <div className="fixed bottom-24 left-4 right-4 z-50 animate-in slide-in-from-bottom-10 duration-500">
      <div className="bg-card-bg text-card-text p-4 rounded-2xl shadow-2xl flex items-center justify-between gap-4 border border-card-border">
        <div className="flex items-center gap-3">
          <div className="bg-brand-yellow p-2 rounded-xl text-brand-brown">
            <ArrowDownTrayIcon className="w-5 h-5" />
          </div>
          <div>
            <h4 className="text-sm font-black leading-tight">Install AgriConnect</h4>
            <p className="text-[10px] font-bold text-app-text-secondary uppercase tracking-tighter">Faster access & Offline support</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button 
            onClick={onInstall}
            className="bg-btn-primary text-btn-primary-text px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-btn-primary-hover transition-colors"
          >
            Install
          </button>
          <button 
            onClick={onDismiss}
            className="p-2 text-app-text-secondary hover:bg-brand-green-50 rounded-full transition-colors"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstaller;